module.exports = __webpack_public_path__ + "img/error-confirmation.f1fd032b.svg";